import { z } from 'zod';
import {} from '../catalog/bedOptions.js';
import {} from '../catalog/bedTypes.js';
import {} from '../time/dateRange.js';
import { dateRangeSchema, idSchema, justificationSchema } from './common.js';
/**
 * Every reason the planner can give for (or against) a placement.
 *
 * Each assignment carries the subset that applies to it, which is what turns a
 * bare "guest 12 → bed 7" into an explanation a human can argue with.
 */
export const PLAN_REASON_CODES = [
    'lock_honoured',
    'bed_favorite',
    'bed_favorite_missed',
    'roommate_together',
    'roommate_separated',
    'incompatible_guest_avoided',
    'incompatible_room_avoided',
    'gender_grouped',
    'traits_grouped',
    'trait_disturbs_roommate',
    'bed_suits_guest',
    'bed_comfort',
    'stay_continuity',
    'guest_relocated',
];
export const DEFAULT_PLAN_WEIGHTS = {
    bedFavorite: 100,
    roommateTogether: 60,
    genderGrouping: 15,
    traitDisturbance: 40,
    bedComfort: 10,
    stayContinuity: 25,
};
export const planWeightsSchema = z.strictObject({
    bedFavorite: z.number().min(0).max(1000),
    roommateTogether: z.number().min(0).max(1000),
    genderGrouping: z.number().min(0).max(1000),
    traitDisturbance: z.number().min(0).max(1000),
    bedComfort: z.number().min(0).max(1000),
    stayContinuity: z.number().min(0).max(1000),
});
export const generatePlanInputSchema = z.strictObject({
    weights: planWeightsSchema.partial().optional(),
    /** Fixed seed keeps a regeneration reproducible; omitted means "use 1". */
    seed: z
        .number()
        .int()
        .min(0)
        .max(2 ** 31 - 1)
        .optional(),
    maxAlternativesPerAssignment: z.number().int().min(0).max(20).optional(),
    /** Lets two mutual room-mates share one double bed. */
    allowSharedDoubleBeds: z.boolean().optional(),
});
export const createPlanLockInputSchema = z.strictObject({
    guestId: idSchema,
    roomId: idSchema,
    /** Pin the exact bed too, or leave null to pin only the room. */
    bedId: idSchema.nullish(),
    /** Defaults to the guest's whole stay when omitted. */
    range: dateRangeSchema.nullish(),
    justification: justificationSchema,
});
//# sourceMappingURL=plans.js.map